module.exports = __webpack_public_path__ + "static/media/cog.348ccc0f.svg";